// @ts-expect-error just for some reason cant find dependency
import { GridInitialStateCommunity } from "@mui/x-data-grid/esm/models/gridStateCommunity";
import { GridApiPro } from "@mui/x-data-grid-pro";
import { useLocalStorage } from "@sinch/hooks/utilities/useLocalStorage";
import React, { RefObject, useLayoutEffect } from "react";

export const useRememberDataGridState = (apiRef: RefObject<GridApiPro | null>, key: string) => {
  const [dataGridState, setDataGridState] = useLocalStorage<GridInitialStateCommunity | undefined>(key, {
    defaultValue: undefined,
  });

  const saveSnapshot = React.useCallback(() => {
    if (apiRef?.current?.exportState) {
      const currentState = apiRef.current.exportState({ exportOnlyDirtyModels: true });
      setDataGridState(currentState);
    }
  }, [apiRef, setDataGridState]);

  useLayoutEffect(() => {
    // handle refresh and navigating away/refreshing
    window.addEventListener("beforeunload", saveSnapshot);

    return () => {
      // in case of an SPA remove the event-listener
      window.removeEventListener("beforeunload", saveSnapshot);
      saveSnapshot();
    };
  }, [saveSnapshot]);
  return dataGridState;
};
